import CsatByAnswerToOtherQuestionWidget from './CsatByAnswerToOtherQuestionWidget';
export default CsatByAnswerToOtherQuestionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByAnswerToOtherQuestionWidget/index.js